import { FiInfo } from "react-icons/fi";

export const GenericBankFeedsInfoIcon = ({
  text,
  hover,
  displayRight,
  onMouseEnter,
  onMouseLeave,
}: {
  text: string;
  hover: boolean;
  displayRight?: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}) => {
  return (
    <div
      className="pl-2"
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
      }}>
      <FiInfo
        size={15}
        style={{ cursor: "pointer", color: "black" }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        aria-label="Info"
      />
      {hover && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: displayRight ? undefined : "125%",
            left: displayRight ? "125%" : undefined,
            transform: "translateY(-50%)",
            backgroundColor: "black",
            color: "white",
            padding: "6px 10px",
            borderRadius: "4px",
            whiteSpace: "nowrap",
            zIndex: 100,
            fontSize: "12px",
            pointerEvents: "none",
          }}>
          {text}
        </div>
      )}
    </div>
  );
};
